import { Injectable } from '@angular/core';
import { PermissionsRepositoryService } from 'app/repositories/permissions-repository.service';
import { PermissionInterface } from '../models/permission.model';

@Injectable({
  providedIn: 'root',
})
export class InitPermissionService {
  userPermissions: PermissionInterface[]; // TARAS: useless for now

  constructor(private readonly _permissionsRepositoryService: PermissionsRepositoryService) {}

  load(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this._permissionsRepositoryService.getPermissions().subscribe((permissions: PermissionInterface[]) => {
        localStorage.setItem('allPermissions', JSON.stringify(permissions));
        this.userPermissions = permissions;
        resolve(true);
      });
    });
  }
}
